module.exports = __webpack_public_path__ + "img/page_image_1_5.7dbcbe71.svg";